import { render, staticRenderFns } from "./AddHoliday.vue?vue&type=template&id=1673935a&scoped=true&"
import script from "./AddHoliday.vue?vue&type=script&lang=js&"
export * from "./AddHoliday.vue?vue&type=script&lang=js&"
import style0 from "./AddHoliday.vue?vue&type=style&index=0&id=1673935a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673935a",
  null
  
)

export default component.exports